import { useTranslation } from 'react-i18next';

export const NativeDateLocaleWrapper = ({ date, options }) => {
  const { i18n } = useTranslation();

  return <>{new Intl.DateTimeFormat(i18n.language === 'ru' ? 'ru' : 'en-US', options).format(new Date(date))}</>;
};
